import { render, staticRenderFns } from "./mix.vue?vue&type=template&id=60fbae80&"
import script from "./mix.vue?vue&type=script&lang=js&"
export * from "./mix.vue?vue&type=script&lang=js&"
import style0 from "./mix.vue?vue&type=style&index=0&id=60fbae80&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports